import React, { useContext, useEffect, useState } from "react";
import Header from "components/header";
import HotelRatesSection from "components/hotel_rates_section";
import Loading from "components/loading";
import MapSection from "components/map_section";
import SearchSection from "components/search_section";
import { StylesActionsContext, StylesDataContext } from "containers/data_context/data_context";
import {
  AppActionsContext,
  BookingActionsContext,
  BookingDataContext,
} from "containers/data_context";
import styles from "./hotel_page.module.css";
import moment from "moment";
import SearchModal from "components/searchModal/searchModal";
import LoginMember from "components/header/member/loginMember";
import reactManifest from "react-manifest";
import SisterPropertSection from "components/sister_properties_section/sister_property_section";
import ReactGA from "react-ga4";
import useHandleNotifications from "hooks/useHandleNotification";
import { Toast } from "react-bootstrap";
import ApiActions from "api_actions";
import MEDIA_QUERIES from "constants/media_queries";
import { useMedia } from "react-media";
import MainFooter from "components/MainFooter";
import BottomTabs from "components/bottom_tab";

export default function HotelPage() {
  const { property, channelId, params, sisterProperties } = useContext(BookingDataContext);
  const { data: sisterPropertiesData } = sisterProperties;

  const themeData = useContext(StylesDataContext);
  const bookingActions = useContext(BookingActionsContext);
  const matchedQueries = useMedia({ queries: MEDIA_QUERIES });
  const [customStyles, setCustomStyles] = useState({});

  const isMobile = matchedQueries.xs || matchedQueries.sm || matchedQueries.md;

  const themeAction = useContext(StylesActionsContext);
  const { init } = useContext(AppActionsContext);
  const { data: propertyData, isLoading } = property;
  const isPropertyPresent = propertyData && !isLoading;
  const { currency, checkinDate, checkoutDate } = params;

  const [data, setData] = useState();
  const [member, setMember] = useState(false);
  const [showSisterProperties, setShowSisterProperties] = useState(true);
  const { notifications, isNotificationExists, hideNotification } = useHandleNotifications();

  const [showModal, setShowModal] = useState(false);
  const mydata = JSON.parse(localStorage.getItem("userInfo"));
  const propertyTitle = property?.data?.title || "IBE";
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname + window.location.search,
    title: "Hotel page",
  });

  useEffect(() => {
    if (!channelId) {
      return;
    }

    const currentUrlWithoutParams = window.location.origin;

    const manifestDetails = {
      short_name: propertyTitle,
      name: propertyTitle,
      icons: [
        {
          src: `${currentUrlWithoutParams}/maskable.png`,
          sizes: "196x196",
          type: "image/png",
          purpose: "any maskable",
        },
        {
          src: `${currentUrlWithoutParams}/logo192.png`,
          sizes: "192x192",
          type: "image/png",
        },
        {
          src: `${currentUrlWithoutParams}/logo256.png`,
          sizes: "256x256",
          type: "image/png",
        },
        {
          src: `${currentUrlWithoutParams}/logo384.png`,
          sizes: "384x384",
          type: "image/png",
        },
        {
          src: `${currentUrlWithoutParams}/logo512.png`,
          sizes: "512x512",
          type: "image/png",
        },
      ],
      start_url: `${currentUrlWithoutParams}/${channelId}`,
      display: "standalone",
      theme_color: "#000000",
      background_color: "#ffffff",
      scope: `${currentUrlWithoutParams}/${channelId}`,
    };

    themeAction.loadThemeData(channelId);
    if (channelId) {
      reactManifest.update(manifestDetails, "#manifest-placeholder");
    }
  }, [themeAction, channelId, propertyTitle]);

  const [propertyInfo, setPropertyInfo] = useState(null);
  useEffect(() => {
    const getData = async () => {
      const data = await ApiActions?.getProperty(channelId);

      setPropertyInfo(data?.data[0]);
    };
    if (channelId) {
      getData();
    }
  }, [channelId]);
  useEffect(() => {
    if (themeData?.theme?.data) {
      const root = document?.documentElement;
      const theme = themeData?.theme?.data["uisettings"];
      let raw_css = themeData?.theme?.data?.custom_css;
      const custom_css = raw_css?.replace(/^"(.*)"$/, "$1");

      if (theme) {
        root.style.setProperty("--navbar-bg-color", theme?.navbar_bg_color);
        root.style.setProperty("--navbar-text-color", theme?.navbar_text_color);
        root.style.setProperty("--primary-color", theme?.primary_color);
        root.style.setProperty("--secondary-color", theme?.secondary_color);
        root.style.setProperty("--header-bg-color", theme?.header_bg_color);
        root.style.setProperty("--header-text-color", theme?.header_text_color);
        root.style.setProperty("--btn-primary-color", theme?.btn_primary_color);
        root.style.setProperty("--btn-secondary-color", theme?.btn_secondary_color);
        root.style.setProperty("--font-family", theme?.font_family);

        // Handle custom CSS if provided
        if (custom_css) {
          setCustomStyles(custom_css);
        }
      }
    }
  }, [themeData]);

  useEffect(() => {
    const handleStorageChange = () => {
      const newData = JSON.parse(localStorage.getItem("userInfo"));
      setData(newData);
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [data]);
  useEffect(() => {
    if ((!data && !mydata) || (channelId && mydata && mydata?.channelId !== channelId)) {
      setTimeout(() => {
        setShowModal(true);
      }, 3000);
    }
  }, [channelId, data, mydata]);

  useEffect(() => {
    init(bookingActions);
  }, [bookingActions, init]);

  useEffect(() => {
    bookingActions.loadClosedDates(channelId);
    bookingActions.getPromotions(channelId);
    bookingActions.getSisterProperties(channelId);
    bookingActions.getNotifications(channelId);
    bookingActions.setParams({ ...params, maxInfantAge: propertyData?.hotelPolicy?.infantMaxAge });
  }, [channelId, bookingActions]);

  useEffect(() => {
    if (!currency && !channelId) {
      return;
    }

    const requestParams = {
      currency,
      checkinDate,
      checkoutDate,
    };

    bookingActions.loadBestOffer(channelId, requestParams);
  }, [bookingActions, channelId, currency, checkinDate, checkoutDate]);

  if (!isPropertyPresent || themeData.isLoading) {
    return <Loading />;
  }
  const isDatesSelected = moment(checkinDate).isValid() && moment(checkoutDate).isValid();

  return (
    <div>
      {customStyles && <style dangerouslySetInnerHTML={{ __html: customStyles }} />}
      <Header property={propertyData} />
      <div className={styles.pageContainer}>
        <div className={styles.searchSection}>
          <SearchSection
            userData={mydata}
            propertyInfo={propertyInfo}
            property={propertyData}
            isDatesSelected={isDatesSelected}
            checkoutDate={checkoutDate}
            checkinDate={checkinDate}
          />
        </div>
        {checkinDate && checkoutDate && (
          <div className={styles.rightSection}>
            {showSisterProperties &&
              isDatesSelected &&
              checkoutDate &&
              checkinDate &&
              sisterPropertiesData &&
              sisterPropertiesData?.length > 0 && (
                <div className={styles.cardContainer}>
                  <SisterPropertSection
                    setShowSisterProperties={setShowSisterProperties}
                    sisterProperties={sisterPropertiesData}
                  />
                </div>
              )}

            <div className={styles.cardContainer}>
              {isDatesSelected && checkoutDate && checkinDate && (
                <HotelRatesSection
                  isMemberShipEnabled={Boolean(propertyInfo?.membership_request_enabled)}
                  setShowLoginModal={setMember}
                  property={propertyData}
                  loading={isLoading}
                />
              )}
            </div>
          </div>
        )}
        {member && (
          <LoginMember
            property={property}
            channelId={channelId}
            setMember={setMember}
            member={member}
          ></LoginMember>
        )}
      </div>
      <div className={styles.floatingSearchContainer}>
        <MapSection property={propertyData} />
      </div>
      {propertyInfo && Boolean(propertyInfo?.membership_request_enabled) && (
        <SearchModal show={showModal} onHide={setShowModal} channelId={channelId} />
      )}
      {!checkinDate && !checkoutDate && !isMobile && (
        <div
          style={{
            position: "absolute",
            right: "5px",
            zIndex: 999,
            bottom: "20px",
          }}
        >
          {notifications?.map((notification, index) => (
            <Toast
              key={index}
              style={{
                backgroundColor: notification?.bg_color || "#333",
                borderRadius: "16px",
                boxShadow: "0 8px 20px rgba(0, 0, 0, 0.3)",
                maxWidth: "400px",
                marginBottom: "15px",
                animation: "fadeSlideIn 0.4s ease-out",
                overflow: "hidden",
                color: notification?.text_color || "#fff",
              }}
              show={isNotificationExists(notification?.name)}
              onClose={() => hideNotification(notification?.name)}
              delay={30000}
              autohide={true}
            >
              <Toast.Header
                closeButton={false}
                style={{
                  backgroundColor: notification?.bg_color,
                  padding: "12px 16px",
                  borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                  borderRadius: "16px 16px 0 0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="d-flex align-items-center">
                  <div style={{ marginRight: "10px" }}>
                    {/* Icon based on notification type (e.g., info, success, warning) */}
                    <span style={{ fontSize: "18px" }}>{notification.icon || "🔔"}</span>
                  </div>
                  <strong style={{ color: notification?.text_color, fontWeight: "bold", flex: 1 }}>
                    {notification?.name}
                  </strong>
                </div>
                <div
                  style={{ color: "white", fontS: "bold" }}
                  onClick={() => hideNotification(notification?.name)}
                >
                  X
                </div>
              </Toast.Header>
              <Toast.Body
                style={{
                  padding: "16px",
                  fontSize: "15px",
                  lineHeight: "1.5",
                  textAlign: "justify",
                  color: notification?.text_color,
                }}
              >
                {notification?.description}
              </Toast.Body>
            </Toast>
          ))}
        </div>
      )}
      <MainFooter />
      <BottomTabs property={propertyData} />
    </div>
  );
}
